import { render } from "./ChannelsContent.vue?vue&type=template&id=16b7c605&ts=true"
import script from "./ChannelsContent.vue?vue&type=script&lang=ts"
export * from "./ChannelsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__